import { Stack, StackProps, Typography, TypographyProps } from '@mui/material';
import { ReactNode } from 'react';

import { LoadingIndicatorIcon } from '@/components/loaders/LoadingIndicatorIcon';

export type SectionHeaderProps = {
    isLoading?: boolean;
    title: string;
    icon?: ReactNode;
    children?: ReactNode;
    variant?: TypographyProps['variant'];
};

export const SectionHeader = ({
    isLoading = false,
    title,
    icon,
    children,
    sx,
    variant = 'h4',
    ...props
}: SectionHeaderProps & StackProps) => (
    <Stack sx={{ flexDirection: 'row', alignItems: 'center', gap: 1, ...sx }} {...props}>
        <LoadingIndicatorIcon isLoading={isLoading}>{icon}</LoadingIndicatorIcon>
        <Typography variant={variant}>{title}</Typography>
        {children}
    </Stack>
);
